import { useTranslation } from 'react-i18next';

import SectionTitle from '../Shared/SectionTitle/SecctionTitle';
import FeatureCard from './FeatureCard/FeatureCard';

import classes from './Features.module.css';

const Features = (props) => {
    const { t } = useTranslation();
    return (
        <section id="features" className={classes.Features}>
            <div className='container'>
                <SectionTitle subtitle={t('features.subtitle')} title={t('features.title')} />
                <div>
                    <div className='row'>
                        <div className='col-4' data-aos="fade-right">
                            <FeatureCard
                                icon={<i className="fa-solid fa-chart-simple"></i>}
                                title={t('features.feature1.title')}
                                description={t('features.feature1.description')} />
                        </div>
                        <div className='col-4' data-aos="fade-down">
                            <FeatureCard
                                icon={<i className="fa-solid fa-gears"></i>}
                                title={t('features.feature2.title')}
                                description={t('features.feature2.description')} />
                        </div>
                        <div className='col-4' data-aos="fade-left">
                            <FeatureCard
                                icon={<i className="fa-solid fa-shield-halved"></i>}
                                title={t('features.feature3.title')}
                                description={t('features.feature3.description')} />
                        </div>
                        <div className='col-4' data-aos="fade-right">
                            <FeatureCard
                                icon={<i className="fa-solid fa-hands-holding-child"></i>}
                                title={t('features.feature4.title')}
                                description={t('features.feature4.description')} />
                        </div>
                        <div className='col-4' data-aos="fade-up">
                            <FeatureCard
                                icon={<i className="fa-solid fa-truck"></i>}
                                title={t('features.feature5.title')}
                                description={t('features.feature5.description')} />
                        </div>
                        <div className='col-4' data-aos="fade-left">
                            <FeatureCard
                                icon={<i className="fa-solid fa-code-pull-request"></i>}
                                title={t('features.feature6.title')}
                                description={t('features.feature6.description')} />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Features;